import { useState, useCallback } from 'react';

/**
 * Se running è controlled, non fa nulla,
 * altrimenti se func ritorna una Promise, mette in running il componente fino alla conclusione della stessa.
 *
 * @param {bool | undefined | null} running stato di running
 * @param {func} func funzione di esecuzione del task
 * @returns {object} oggetto con controlled, running e func.
 */
function useRunningState(func, running) {
  const controlled = running !== null && running !== undefined;

  const [runningUnc, setRunningUnc] = useState(false); // se controlled

  const funcUnc = useCallback(
    (evt) => {
      // se controlled
      setRunningUnc(true);
      const result = func(evt);
      if (result instanceof Promise) {
        result.then(() => setRunningUnc(false), () => setRunningUnc(false));
      } else {
        setRunningUnc(false);
      }
    },
    [func],
  );

  return controlled
    ? { controlled, running, func }
    : { controlled, running: runningUnc, func: funcUnc };
}

export default useRunningState;
